import { useState } from 'react';
import { trpc } from '../../utils/trpc/trpc.ts';
import { DiagnosticsTable } from './diagnosticsTable.tsx';
import { RestartDialog } from './restartDialog.tsx';


export function Diagnostics() {

    const DIAGNOSTICS_TABLE_HEIGHT = 229;
    const [isRestartDialogOpen, setIsRestartDialogOpen] = useState(false);


    const { data: diagnosticsResults } = trpc.serverState.getDiagnostics.useQuery(undefined, {
        refetchInterval: 30_000,
    });

    const { data: isAdmin } = trpc.user.isAdmin.useQuery(undefined, {
        refetchOnWindowFocus: false,
    });

    function handleRestartClicked() {
        setIsRestartDialogOpen(true);
    }

    function handleRestartCalled() {
        setIsRestartDialogOpen(false);
        setTimeout(() => window.location.reload(), 5000);
    }


    return (
        <>
            <h1>Server status</h1>
            {!diagnosticsResults ? (
                <div
                    style={{
                        height: `${DIAGNOSTICS_TABLE_HEIGHT}px`,
                        alignItems: 'center',
                        display: 'flex',
                    }}
                >
                    Loading...
                </div>
            ) : (
                <DiagnosticsTable diagnosticsResults={diagnosticsResults} />
            )}
            <div style={{ marginTop: '20px', display: 'flex', gap: '10px' }}>
                <button
                    onClick={() =>
                        window.open(
                            import.meta.env.HELP_URL_ENG,
                            '_blank',
                            'noopener,noreferrer'
                        )
                    }
                >
                    Help
                </button>
                {isAdmin && (
                    <button onClick={handleRestartClicked}>Restart app</button>
                )}
            </div>
            <RestartDialog
                isOpen={isRestartDialogOpen}
                diagnostics={diagnosticsResults}
                onRestartCalled={handleRestartCalled}
                onClose={() => setIsRestartDialogOpen(false)}
            />
        </>
    );
}